import { DetailedHTMLProps, forwardRef, HTMLAttributes, ReactNode } from 'react'

interface ISortableOverlayProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children?: ReactNode
}
export const SortableOverlay = forwardRef<HTMLDivElement, ISortableOverlayProps>((props, ref) => {
  return <div ref={ref} {...props} />
})
